import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class Intent extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, Intent.types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static NONE = new AString('None');
    public static PRIMARY = new AString('Primary');
    public static SUCCESS = new AString('Success');
    public static WARNING = new AString('Warning');
    public static DANGER = new AString('Danger');

    public static types:Array<AString> = [
        Intent.NONE,
        Intent.PRIMARY,
        Intent.SUCCESS,
        Intent.WARNING,
        Intent.DANGER
    ];

    public static none():Intent
    {
        return new Intent(Intent.NONE);
    }

    public static primary():Intent
    {
        return new Intent(Intent.PRIMARY);
    }

    public static success():Intent
    {
        return new Intent(Intent.SUCCESS);
    }

    public static warning():Intent
    {
        return new Intent(Intent.WARNING);
    }

    public static danger():Intent
    {
        return new Intent(Intent.DANGER);
    }
}
